import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import { addNotification } from './notifications';
import {saveFile} from "../lib/content-lib";

export const GET_ISSUES_REQUEST = 'GET_ISSUES_REQUEST';
export const GET_ISSUES_SUCCESS = 'GET_ISSUES_SUCCESS';
export const GET_ISSUES_ERROR = 'GET_ISSUES_ERROR';

export const GET_ISSUE_REQUEST = 'GET_ISSUE_REQUEST';
export const GET_ISSUE_SUCCESS = 'GET_ISSUE_SUCCESS';
export const GET_ISSUE_ERROR = 'GET_ISSUE_ERROR';

export const CREATE_ISSUE_REQUEST = 'CREATE_ISSUE_REQUEST';
export const CREATE_ISSUE_SUCCESS = 'CREATE_ISSUE_SUCCESS';
export const CREATE_ISSUE_ERROR = 'CREATE_ISSUE_ERROR';

export const UPDATE_ISSUE_REQUEST = 'UPDATE_ISSUE_REQUEST';
export const UPDATE_ISSUE_SUCCESS = 'UPDATE_ISSUE_SUCCESS';
export const UPDATE_ISSUE_ERROR = 'UPDATE_ISSUE_ERROR';

export const UPLOAD_ISSUE_FILES_REQUEST = 'UPLOAD_ISSUE_FILES_REQUEST';
export const UPLOAD_ISSUE_FILES_PROGRESS = 'UPLOAD_ISSUE_FILES_PROGRESS';
export const UPLOAD_ISSUE_FILES_SUCCESS = 'UPLOAD_ISSUE_FILES_SUCCESS';
export const UPLOAD_ISSUE_FILES_ERROR = 'UPLOAD_ISSUE_FILES_ERROR';

export const DELETE_ISSUE_FILE_REQUEST = 'DELETE_ISSUE_FILE_REQUEST';
export const DELETE_ISSUE_FILE_SUCCESS = 'DELETE_ISSUE_FILE_SUCCESS';
export const DELETE_ISSUE_FILE_ERROR = 'DELETE_ISSUE_FILE_ERROR';

export const DELETE_ISSUE_REQUEST = 'DELETE_ISSUE_REQUEST';
export const DELETE_ISSUE_SUCCESS = 'DELETE_ISSUE_SUCCESS';
export const DELETE_ISSUE_ERROR = 'DELETE_ISSUE_ERROR';

export const CLEAN_ISSUES = 'CLEAN_ISSUES';

// Get issues
export function getIssues(query) {
    return async (dispatch) => {
        try {
            dispatch(getIssuesRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/issues/query', query, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getIssuesSuccess, getIssuesError));
        } catch (err) {
            dispatch(utilsLib.response(err, getIssuesError));
        }
    };
}
function getIssuesRequest() {
    return {
        type: GET_ISSUES_REQUEST,
        isFetching: true
    };
}
function getIssuesSuccess (payload) {
    return {
        type: GET_ISSUES_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getIssuesError(errorMessage) {
    return {
        type: GET_ISSUES_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Get issue
export function getIssue(issueId) {

    return async (dispatch) => {
        try {
            dispatch(getIssueRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/issues/${issueId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getIssueSuccess, getIssueError));
        } catch (err) {
            dispatch(utilsLib.response(err, getIssueError));
        }
    };
}
function getIssueRequest() {
    return {
        type: GET_ISSUE_REQUEST,
        isFetching: true
    };
}
function getIssueSuccess (payload) {
    return {
        type: GET_ISSUE_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getIssueError(errorMessage) {
    return {
        type: GET_ISSUE_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Create issue
export function createIssue(issue, options) {
    return async (dispatch) => {
        try {
            dispatch(createIssueRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/issues', {issue, options}, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, createIssueSuccess, createIssueError));
        } catch (err) {
            dispatch(utilsLib.response(err, createIssueError));
        }
    };
}
function createIssueRequest() {
    return {
        type: CREATE_ISSUE_REQUEST,
        isFetching: true
    };
}
function createIssueSuccess (payload) {
    return dispatch => {
        // Create notification for create issue success
        dispatch(addNotification({
            message: 'Albaran añadido correctamente',
            color: 'green',
            icon: 'tick'
        }));

        dispatch({
            type: CREATE_ISSUE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function createIssueError(errorMessage) {
    return dispatch => {
        // Create notification for create issue error
        dispatch(addNotification({
            message: 'Error al añadir el albaran',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CREATE_ISSUE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Update issue
export function updateIssue(issueId, issue = {}) {
    return async (dispatch) => {
        try {
            dispatch(updateIssueRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/issues/${issueId}`, issue, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateIssueSuccess, updateIssueError));
        } catch (err) {
            dispatch(utilsLib.response(err, updateIssueError));
        }
    };
}
function updateIssueRequest() {
    return {
        type: UPDATE_ISSUE_REQUEST,
        isFetching: true
    };
}
function updateIssueSuccess (payload) {
    return dispatch => {
        // Create notification for update issue success
        dispatch(addNotification({
            message: 'Albaran actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPDATE_ISSUE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function updateIssueError(errorMessage) {
    return dispatch => {
        // Create notification for update issue error
        dispatch(addNotification({
            message: 'Error al actualizar el albaran',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPDATE_ISSUE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Upload issue files
export function uploadIssueFiles(issueId, files) {
    return async (dispatch) => {
        try {
            dispatch(uploadIssueFilesRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post(`/api/issues/${issueId}/files`, files, {
                headers: { 'Authorization': 'Bearer ' + token },
                onUploadProgress: function (e) {
                    dispatch(uploadIssueFilesProgress(e.loaded / e.total))
                }
            });

            dispatch(utilsLib.response(res, uploadIssueFilesSuccess, uploadIssueFilesError));
        } catch (err) {
            dispatch(utilsLib.response(err, uploadIssueFilesError));
        }
    };
}
function uploadIssueFilesRequest() {
    return {
        type: UPLOAD_ISSUE_FILES_REQUEST,
        isFetching: true
    };
}
function uploadIssueFilesProgress(percent) {
    return {
        type: UPLOAD_ISSUE_FILES_PROGRESS,
        percent
    };
}
function uploadIssueFilesSuccess (payload) {
    return dispatch => {
        // Create notification for upload issue file success
        dispatch(addNotification({
            message: 'Ficheros subidos correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPLOAD_ISSUE_FILES_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function uploadIssueFilesError(errorMessage) {
    return dispatch => {
        // Create notification for upload issue file error
        dispatch(addNotification({
            message: 'Error al subir los ficheros',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPLOAD_ISSUE_FILES_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Download issue file
export function downloadIssueFile(issueId, fileId) {
    return async (dispatch) => {
        try {
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/issues/${issueId}/files/${fileId}`, {
                headers: { 'Authorization': 'Bearer ' + token },
                responseType: 'blob'
            });

            if( res.status === 200 ) {
                saveFile(res);
            }

        } catch (err) {
            dispatch(addNotification({
                message: 'Error al descargar el fichero',
                color: 'red',
                icon: 'warning-sign'
            }));
        }
    };
}

// Delete issue file
export function deleteIssueFile(issueId, fileId) {
    return async (dispatch) => {
        try {
            dispatch(deleteIssueFileRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/issues/${issueId}/files/${fileId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteIssueFileSuccess, deleteIssueFileError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteIssueFileError));
        }
    };
}
function deleteIssueFileRequest() {
    return {
        type: DELETE_ISSUE_FILE_REQUEST,
        isFetching: true
    };
}
function deleteIssueFileSuccess (payload) {
    return dispatch => {
        // Create notification for delete file success
        dispatch(addNotification({
            message: 'Fichero eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_ISSUE_FILE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deleteIssueFileError(errorMessage) {
    return dispatch => {
        // Create notification for delete file error
        dispatch(addNotification({
            message: 'Error al eliminar el fichero',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_ISSUE_FILE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Delete issue
export function deleteIssue(issueId) {

    return async (dispatch) => {
        try {
            dispatch(deleteIssueRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/issues/${issueId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteIssueSuccess, deleteIssueError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteIssueError));
        }
    };
}
function deleteIssueRequest() {
    return {
        type: DELETE_ISSUE_REQUEST,
        isFetching: true
    };
}
function deleteIssueSuccess (payload) {
    return dispatch => {
        // Create notification for delete issue success
        dispatch(addNotification({
            message: 'Albaran eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_ISSUE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deleteIssueError(errorMessage) {
    return dispatch => {
        // Create notification for delete issue error
        dispatch(addNotification({
            message: 'Error al eliminar el albaran',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_ISSUE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Clean issues reducer
export function cleanIssues() {
    return {
        type: 'CLEAN_ISSUES',
        isFetching: false,
        error: false,
        payload: []
    }
}



// WEBPACK FOOTER //
// ./src/actions/issues.js